import { Box } from '@material-ui/core';
import styled from 'styled-components';

export const ContainerColorDefault = styled.div`
  margin-top: 10px;

  display: flex;
  gap: 8px;
  width: 100%;

  @media (min-width: 768px) {
    flex-direction: column;
  }

  p {
    font-weight: 400;
    font-size: 14px;
    color: #9e9e9e;
    margin-bottom: 5px;
  }

  div {
    flex: 1;
  }

  div + p {
    margin-top: 5px;
  }
`;

export const ContainerColor = styled.div<{ bgColor: string }>`
  width: 100%;
  height: 30px;
  background-color: ${(props) => props.bgColor};
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.5s;

  & + & {
    margin-top: 5px;
  }

  span {
    filter: invert(1);
    color: ${(props) => props.bgColor};
  }
`;

export const SaveColorButton = styled.button`
  width: 100%;
  height: 30px;
  border: 1px solid #3f51b5;
  background-color: #3f51b5;
  color: #fff;
  border-radius: 5px;
  transition: 0.5s;

  :hover {
    opacity: 0.8;
  }

  :disabled {
    background-color: #00000044;
    border-color: #00000044;
    cursor: no-drop;
  }

  &.redefinir-cores {
    background-color: transparent;
    color: #f64444;
    border-color: #f64444;
  }

  &.redefinir-cores:hover {
    background-color: #f64444;
    color: #fff;
  }
`;

export const ModalContainer = styled.div`
  width: 300px;
  background: #fff;
  padding: 10px 15px 15px;
  border-radius: 5px;
  position: relative;

  h1 {
    text-align: center;
    font-weight: 700;
    font-size: 20px;
    color: #263238;
    margin-top: 5px;
  }

  p {
    margin-bottom: 10px;
  }

  .closeModal {
    position: absolute;
    top: 12px;
    right: 12px;
    border: none;
    font-size: 20px;
    color: #555;
    background: transparent;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    transition: 0.3s;

    :hover {
      background: red;
      color: white;
    }
  }
`;

export const Container = styled.div`
  padding: 15px 0 30px 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  padding: 0;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

export const CustomBox = styled(Box)`
  width: 100%;
  padding: 10px 15px 20px;

  @media (min-width: 768px) {
    width: 200px;
  }
`;

export const ContainerButton = styled.div`
  max-width: 250px;
  display: flex;
  gap: 10px;
  flex-direction: column;
  margin: 30px auto 0px;
`;
